import Title from "../components/Title";
import longDecor from "../assets/long-decor.svg";
import shortDecor from "../assets/short-decor.svg";
function Contact() {
  return (
    <section className="mt-20 lg:mt-48 mb-14 relative" id="contact">
      <div className="el-container-lg flex flex-col items-center max-w-lg ">
        <Title title="Contact Me" />
        <p className="text-center mt-4 leading-7	">
          Whether you want to hire me or just want to say hi, feel free to contact me. I’ll get back
          to you as soon as I can!
        </p>
        <form
          className="flex flex-col gap-6 mt-8 w-full z-10"
          action="https://formsubmit.co/parsadev27@gmail.com"
          method="POST"
        >
          <label className="flex flex-col gap-2 text-textGrey">
            <span className="text-sm">name:</span>
            <input
              className="bg-backgroundLighter "
              type="text"
              name="name"
              required
              autoComplete="off"
            />
          </label>
          <label className="flex flex-col gap-2 text-textGrey">
            <span className="text-sm">email:</span>
            <input type="email" name="email" required autoComplete="off" />
          </label>
          <label className="flex flex-col gap-2 text-textGrey">
            <span className="text-sm">massage:</span>
            <textarea name="textarea" cols="30" rows="8"></textarea>
          </label>
          <button className="bg-primary" type="submit">
            Send
          </button>
        </form>
      </div>
      {/* decoration asset */}
      <div className="absolute el-decor top-0 left-0">
        <img src={longDecor} alt="" />
      </div>
      <div className="absolute el-decor top-1/2 right-0">
        <img src={shortDecor} alt="" />
      </div>
      <div className="absolute el-decor bottom-0 -left-16">
        <img src={longDecor} alt="" />
      </div>
    </section>
  );
}

export default Contact;
